import React from 'react';

import Button from '../../../components/ui/Button';

const BlogPagination = ({ currentPage, totalPages, onPageChange, totalArticles, postsPerPage }) => {
  const getVisiblePages = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  const visiblePages = getVisiblePages();

  return (
    <section className="bg-background py-12 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Previous Button */}
          <Button
            variant="outline"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            iconName="ChevronLeft"
            iconPosition="left"
            className="flex-shrink-0"
          >
            Previous
          </Button>

          {/* Page Numbers */}
          <div className="hidden sm:flex items-center gap-2">
            {visiblePages.map((page, index) => {
              if (page === '...') {
                return (
                  <span key={`dots-${index}`} className="px-3 py-2 text-text-muted">
                    ...
                  </span>
                );
              }

              return (
                <button
                  key={page}
                  onClick={() => onPageChange(page)}
                  className={`px-4 py-2 rounded-lg font-medium text-sm transition-smooth ${
                    currentPage === page
                      ? 'bg-accent text-white shadow-lg'
                      : 'text-text-secondary hover:text-text-primary hover:bg-white/5 border border-transparent hover:border-white/10'
                  }`}
                >
                  {page}
                </button>
              );
            })}
          </div>

          {/* Mobile Page Info */}
          <div className="sm:hidden flex items-center gap-2 text-sm text-text-secondary">
            <span>Page {currentPage} of {totalPages}</span>
          </div>

          {/* Next Button */}
          <Button
            variant="outline"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            iconName="ChevronRight"
            iconPosition="right"
            className="flex-shrink-0"
          >
            Next
          </Button>
        </div>

        {/* Results Info */}
        <div className="text-center mt-6">
          <p className="text-sm text-text-muted">
            Showing page {currentPage} of {totalPages} (
            {Math.min(currentPage * postsPerPage, totalArticles)} of {totalArticles} articles)
          </p>
        </div>
      </div>
    </section>
  );
};

export default BlogPagination;